'use client'
import { ActiveUser } from '@/lib/services/accountService';
import { COOKIE_VISTOR_ID, Utils } from '@/lib/utils';
import { Project } from '@prisma/client';
import { getCookie } from 'cookies-next';
import { useParams } from 'next/navigation';
// import { LOCALSTORAGE_CURRENT_WORKSPACE_ID, Utils } from '@/lib/constants';
// import { CalendarService } from '@/lib/services/calendarService';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';



type AppContextType = {
      currentUser: ActiveUser | null;
      selectedProject: Project | null;
      setSelectedProject: (project: Project | null) => void;
      titlePage: string;
      setTitle: (title: string, canGoBack?: boolean) => void;
      canGoBack: boolean;
      // currentUserPlan: Plan;
      // currentUserSubscription: Subscription;
      // changeLocale: (newLocale: AppLocale) => void;

      updateUserPicture: (newProfilePicture: string | null) => void;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

type AppProviderProps = {
      children: ReactNode;
      user: ActiveUser | null;
      defaultProject?: Project | null;
};

export function AppProvider({ children, user, defaultProject }: AppProviderProps) {
      const [currentUser, setCurrentUser] = useState<ActiveUser | null>(user);
      const [selectedProject, setSelectedProject] = useState<Project | null>(defaultProject ?? null);
      const [titlePage, setTitlePage] = useState<string>('');
      const [canGoBack, setCanGoBack] = useState<boolean>(false);
      const params = useParams();
      const projectId = params?.projectId as string;

      useEffect(() => {
            manageVisitorId();
      }, []);

      useEffect(() => {
            if (projectId && user) {

                  let project = user.ownedProjects.find(p => p.id === projectId);
                  if (!project) {
                        project = user.memberships.find(m => m.projectId === projectId)?.project;
                  }
                  if (project) {
                        setSelectedProject(project);
                  }
            }
      }, [projectId, user]);

      const setTitle = (title: string, canGoBack?: boolean) => {
            setTitlePage(title);
            setCanGoBack(canGoBack ?? false);
      }

      const updateUserPicture = (newProfilePicture: string | null) => {
            if (currentUser) {
                  setCurrentUser({ ...currentUser, image: newProfilePicture });
            }
      }


      const manageVisitorId = () => {
            const visitorId = getCookie(COOKIE_VISTOR_ID);
            if (!visitorId) {
                  Utils.cookie.setSmart(COOKIE_VISTOR_ID, crypto.randomUUID());
            }
      }

      return (
            <AppContext.Provider value={{
                  currentUser,
                  selectedProject,
                  setSelectedProject,
                  titlePage,
                  setTitle,
                  canGoBack,
                  updateUserPicture
            }}>
                  {children}
            </AppContext.Provider>
      );
}

// Hook para usar o contexto
export const useAppContext = () => {
      const context = useContext(AppContext);
      if (!context) {
            throw new Error("useAppContext deve ser usado dentro do AppProvider");
      }
      return context;
};